class OmtRail extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.sec, section');
    section?.querySelector('[data-omt-rail-prev]')?.addEventListener('click', () => this.scrollByPage(-1));
    section?.querySelector('[data-omt-rail-next]')?.addEventListener('click', () => this.scrollByPage(1));

    let isDown = false;
    let startX = 0;
    let startLeft = 0;
    let moved = 0;

    this.addEventListener('pointerdown', (event) => {
      if (event.target.closest('a, button')) return;
      isDown = true;
      moved = 0;
      startX = event.clientX;
      startLeft = this.scrollLeft;
      this.classList.add('dragging');
    });
    this.addEventListener('pointermove', (event) => {
      if (!isDown) return;
      const delta = event.clientX - startX;
      moved = Math.abs(delta);
      this.scrollLeft = startLeft - delta;
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach((type) => {
      this.addEventListener(type, () => {
        isDown = false;
        this.classList.remove('dragging');
      });
    });
    this.addEventListener('click', (event) => {
      if (moved > 6) event.preventDefault();
    });
  }

  scrollByPage(direction) {
    this.scrollBy({ left: this.clientWidth * 0.8 * direction, behavior: 'smooth' });
  }
}
customElements.define('omt-rail', OmtRail);
